import React from 'react';
import Navigation from '../components/Navigation';
import SnowflakesEffect from '../components/SnowflakesEffect';
import { isChristmasPeriod } from '../utils/christmasTheme';
import '../styles/HowItWorksPage.css';
import '../styles/christmas.css';

const HowItWorksPage: React.FC = () => {
  const isChristmas = isChristmasPeriod();
  
  return (
    <div className={`how-it-works-page ${isChristmas ? 'christmas' : ''}`}>
      {isChristmas && <SnowflakesEffect />}
      {isChristmas && <div className="christmas-overlay" />}
      <Navigation />
      <div className="page-content">
        <div className="content-container">
          <h1 className="page-title">How It Works</h1>
          <div className="steps-container">
            <div className="step">
              <div className="step-number">1</div>
              <h2 className="step-title">Try a Demo First (Optional)</h2>
              <p className="step-description">
                Want to see how it works? Click "Drink a Demo ThanksBeer" at the bottom 
                of the homepage to experience receiving a ThanksBeer yourself. You'll see 
                the full experience including time-aware messages and the completion screen.
              </p>
            </div>
            
            <div className="step">
              <div className="step-number">2</div>
              <h2 className="step-title">Enter Your Details (Optional)</h2>
              <p className="step-description">
                On the homepage, you can optionally enter your name, the recipient's name, 
                and a kudos message. All fields are optional - customize as much or as little 
                as you want!
              </p>
            </div>
            
            <div className="step">
              <div className="step-number">3</div>
              <h2 className="step-title">Click "Give a ThanksBeer"</h2>
              <p className="step-description">
                Simply click the golden button to generate a unique link for your 
                virtual beer. It's instant and easy!
              </p>
            </div>
            
            <div className="step">
              <div className="step-number">4</div>
              <h2 className="step-title">Share the Link</h2>
              <p className="step-description">
                Copy the URL and share it with your recipient via text, email, social 
                media, or any messaging platform. They'll see who it's from and any 
                message you included!
              </p>
            </div>
            
            <div className="step">
              <div className="step-number">5</div>
              <h2 className="step-title">They Drink It!</h2>
              <p className="step-description">
                When your recipient opens the link, they'll see a personalized greeting 
                with a time-aware message (like "Well timed" or "End of day. Deserved"). 
                They click "DRINK" to enjoy the experience!
              </p>
            </div>
            
            <div className="step">
              <div className="step-number">6</div>
              <h2 className="step-title">Completion & Share</h2>
              <p className="step-description">
                After drinking, they see "This one's done" along with options to send 
                their own ThanksBeer or (for demos) try another one. The viral loop 
                keeps the gratitude flowing!
              </p>
            </div>
            
            <div className="step">
              <div className="step-number">7</div>
              <h2 className="step-title">Cheers! 🍺</h2>
              <p className="step-description">
                Mission accomplished! You've just made someone's day a little brighter 
                with a digital cheers and spread positivity.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorksPage;
